import { Component, ComponentFactoryResolver } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { BrowseComponent } from 'src/app/shared/components/browse/browse.component';
import { DataGridColumn } from 'src/app/shared/components/datagrid/datagrid-core.component';
import { PedidoIntervencaoBrowseFilterComponent } from './pedidoIntervencao-browse-filter.component';
import { PedidoIntervencaoSearchFilter } from '../../../model/pedidoIntervencao/pedidoIntervencaoSearchFilter';
import { PedidoIntervencaoDataService } from '../../../core/services/pedidoIntervencao-crud.service';
import { PedidoIntervencao } from '../../../model/pedidoIntervencao/pedidoIntervencao';
import { Observable } from 'rxjs';
import { SecurityService } from 'src/app/shared/services/security.service';

@Component({
    selector: 'app-pedidointervencao-browse',
    templateUrl: '../../../shared/components/browse/browse.component.html',
    standalone: false
})
export class PedidoIntervencaoBrowseComponent extends BrowseComponent<PedidoIntervencao> {

  constructor(
    protected componentFactoryResolver: ComponentFactoryResolver,
    protected router: Router, protected route: ActivatedRoute,
    protected modalService: NgbModal,
    protected dataService: PedidoIntervencaoDataService,
    protected securityService: SecurityService) {

    super(componentFactoryResolver, router, route, modalService, dataService);

    this.title = 'Pedidos de Intervenção';
    this.componentFilter = PedidoIntervencaoBrowseFilterComponent;
    this.browseRouterLink = '/pedidoIntervencao';
    this.manageRouterLink = '/pedidoIntervencao';
    this.globalMessage = '';
    this.canDelete = false;
    this.autoFilter = true;
    this.canDeleteHandler = false;
    this.exportReportLabel = 'Dias imobilização';
    this.showExportReport = false;
    this.showExportExcel = false;
    this.exportAnalysisLabel = 'Análise Pedidos';
    this.showExportAnalysis = this.GetPermission(6006);
    this.showAdd = true;

    this.acompanhamentoCallback = this.getAcompanhamento;
    this.exportReportCallback = this.getDiasImobilizacao;
    this.exportAnalysisCallBack = this.getAnalise;

    this.filter = new PedidoIntervencaoSearchFilter();
    this.filter.pageNumber = 1;
    this.filter.pageSize = 10;
    this.filter.returnTotalCount = true;

    this.columns.push(
      new DataGridColumn(
        'pedidoIntervencaoId', 'Nº',
        '[{"width": "60px", "textAlign": "right","hyperLink": false}]'
      ));

    this.columns.push(
      new DataGridColumn(
        'data', 'Data',
        '[{"width": "102px", "textAlign": "center", "formatDate": true }]'
      ));

    this.columns.push(
      new DataGridColumn(
        'dataEntradaOficina', 'Ent. Oficina',
        '[{"width": "102px", "textAlign": "center", "formatDate": true }]'
      ));

    this.columns.push(
      new DataGridColumn(
        'estado', 'Estado',
        '[{"width": "117px", "textAlign": "left", "formatDate": false }]'
      ));

    this.columns.push(
      new DataGridColumn(
        'numContrato', 'Contrato',
        '[{"width": "70px", "textAlign": "center", "formatDate": false }]'
      ));

    this.columns.push(
      new DataGridColumn(
        'matricula', 'Matrícula',
        '[{"width": "75px", "textAlign": "center", "formatDate": false }]'
      ));

    this.columns.push(
      new DataGridColumn(
        'produto', 'Modelo',
        '[{"width": "190px", "textAlign": "left", "formatDate": false }]'
      ));

    this.columns.push(
      new DataGridColumn(
        'centroCusto', 'Centro Custo',
        '[{"width": "180px", "textAlign": "left", "formatDate": false }]'
      ));

    this.columns.push(
      new DataGridColumn(
        'fornecedor', 'Fornecedor',
        '[{"width": "220px", "textAlign": "left", "formatDate": false }]'
      ));

    this.columns.push(
      new DataGridColumn(
        'numKms', 'Kms',
        '[{"width": "70px", "textAlign": "center" }]'
      ));

    this.columns.push(
      new DataGridColumn(
        '', '',
        '[{"width": "2%", "hyperLink": false, "singleButton": true, "buttonText": "acompanhamento", "buttonAcompanhamento": true }]'
      ));

    this.columns.push(
      new DataGridColumn(
        '', '',
        '[{"width": "2%", "hyperLink": false, "singleButton": true, "buttonText": "edit", "buttonEdit": true }]'
      ));
  }

  public getAcompanhamento = (pedidoIntervencaoId: number): Observable<any> => {
    return this.dataService.getAcompanhamento(pedidoIntervencaoId);
  }

  public getDiasImobilizacao = (filter: any): Observable<any> => {
    return this.dataService.SearchDiasImobilizacao(filter);
  }

  public getAnalise = (filter: any): Observable<any> => {
    return this.dataService.SearchAnalise(filter);
  }

  private GetPermission = (lockId: number): boolean => {
    return this.securityService.canDisplay(lockId);
  }

}
